export const ADD_BRAND_LISTENER = 'ADD_BRAND_LISTENER';
export const REMOVE_ALL_BRAND_LISTENERS = 'REMOVE_ALL_BRAND_LISTENERS';

const intialState = [];

export default (state = intialState, action) => {
  switch (action.type) {
    case ADD_BRAND_LISTENER:
      return [...state, action.payload];
    case REMOVE_ALL_BRAND_LISTENERS:
      return [];
    default:
      return state;
  }
};
